<template>
  <div v-loading="loading" class="p-5 flex flex-col h-full">
    <div class="border border-radius w-full flex flex-col h-[190px]">
      <div class="bg-[#F3F8FB] h-9 leading-9 text-black px-[10px]">
        <span>日期时间</span>
        <span class="pl-1">=</span>
      </div>
      <codemirror ref="cm" class="grow w-full code" :options="cmOptions" />
    </div>
    <div class="flex flex-row mt-[10px] h-[300px] overflow-y-auto text-xs">
      <div class="w-1/3">
        <div class="flex flex-col h-full">
          <div class="text-gray-500 leading-[18px] mb-1">可用变量</div>
          <div class="border grow fields overflow-y-auto">
            <el-tree :data="fields" @node-click="onFieldNodeClick" />
          </div>
        </div>
      </div>
      <div class="w-2/3 pl-2">
        <div class="flex flex-col h-full">
          <div class="text-gray-500 leading-[18px] mb-1">函数</div>
          <div class="grow flex-row flex">
            <div class="border w-1/3 methods">
              <el-tree :data="methods" @node-click="onMethodClick">
                <span slot-scope="{ node, data }" class="w-full" @mouseover="onMethodHover(data)">
                  <span>{{ node.label }}</span>
                </span>
              </el-tree>
            </div>
            <div class=" w-2/3 pl-2">
              <div class="border w-full h-full">
                <div v-if="currentMethod" class="h-[35px] leading-[35px] border-b pl-4">{{ currentMethod.label }}</div>
                <ul v-if="currentMethod" class="pt-1">
                  <li class=" py-[2px] px-[10px]" v-html="currentMethod.intro" />
                  <li class=" py-[2px] px-[10px]" v-html="'用法：' + currentMethod.usage" />
                  <li class=" py-[2px] px-[10px]" v-html="'示例：' + currentMethod.example" />
                </ul>
                <ul v-else>
                  <li class="py-[2px] px-[10px]">
                    从左侧面板选择字段名和函数，或输入函数
                  </li>
                  <li class="py-[2px] px-[10px]">
                    公式编辑举例：<span class="text-[#761086]">AVERAGE</span>(<span class="formula-field">语文成绩</span>,<span
                      class="formula-field"
                    >数学成绩</span>)
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mt-1 text-right">
      <el-button type="primary" @click="onConfirm">确定</el-button>
    </div>
  </div>
</template>

<script>
import {codemirror} from 'vue-codemirror'
import CodeMirror from 'codemirror'
// require styles
import 'codemirror/lib/codemirror.css'
import './code'
import axios from 'axios'
import zroute from '../../ziggy'
import {getAllWidgets} from '../../utils'

export default {
  name: 'FormulaEditor',
  components: {
    codemirror,
  },
  props: {
    value: {
      type: Object,
      default: () => ({
        formula: {
          formula: '',
          text: '公式',
          type: 'formula',
        },
        widgets: [],
      }),
    },
    widgets: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      currentMethod: null,
      loading: false,
      form_id: zroute().params.form_id,
      app_id: zroute().params.app_id,
      form: [],
      rely: this.value,
      methods: [
        {
          label: '常用函数', children: [
            {
              id: 'ROUND',
              label: 'ROUND',
              intro: '<span class="text-[#761086]">ROUND</span>函数可以将数字四舍五入到指定的位数',
              usage: '<span class="text-[#761086]">ROUND</span>(数字,小数位数)',
              example: '<span class="text-[#761086]">ROUND</span>(123.456,2)',
            },
            {
              id: 'AVERAGE',
              label: 'AVERAGE',
              intro: '<span class="text-[#761086]">AVERAGE</span>函数可以获取一组数值的算术平均值',
              usage: '<span class="text-[#761086]">AVERAGE</span>(数字1,数字2,...)',
              example: '<span class="text-[#761086]">AVERAGE</span>(语文成绩,数学成绩, 英语成绩)返回三门课程的平均分',
            },
            {
              id: 'MAX',
              label: 'MAX',
              intro: '<span class="text-[#761086]">MAX</span>函数可以获取一组数值的最大值',
              usage: '<span class="text-[#761086]">MAX</span>(数字1,数字2,...)',
              example: '<span class="text-[#761086]">MAX</span>(语文成绩,数学成绩,英语成绩)返回三门课程中的最高分',
            },
            {
              id: 'MIN',
              label: 'MIN',
              intro: '<span class="text-[#761086]">MIN</span>函数可以获取一组数值的最小值',
              usage: '<span class="text-[#761086]">MIN</span>(数字1,数字2,...)',
              example: '<span class="text-[#761086]">MIN</span>(语文成绩,数学成绩,英语成绩)返回三门课程中的最低分',
            },
          ],
        },
      ],
      cmOptions: {
        lineNumbers: false,
        matchBrackets: true,
        extraKeys: {'Tab': 'indentAuto'},
      },
    }
  },
  computed: {
    fields() {
      return [
        {label: '当前表单字段', children: getAllWidgets(this.widgets).map(widget => ({id: widget.key, label: widget.name, entry: ''}))},
        {
          label: '所有表单字段',
          children: this.form.map(form => ({
            label: form.name,
            children: form.fields.map(field => ({id: field.name, label: field.text, entry: form.id})),
          })),
        },
      ]
    },
    codemirror() {
      return this.$refs.cm.codemirror
    },
  },
  created() {
    this.getFields()
    console.log(this.rely, this.widgets)
    this.$nextTick(() => {
      this.setValue()
    })
  },
  methods: {
    onMethodHover(data) {
      console.log('onMethodHover', data)
      if (!data.id) {
        return
      }
      this.currentMethod = data
    },
    onMethodClick(data) {
      if (!data.id) {
        return
      }
      this.codemirror.focus()
      const pos = this.codemirror.getCursor()
      this.codemirror.replaceSelection(data.label + '()')
      this.codemirror.setCursor({
        line: pos.line,
        ch: pos.ch + data.label.length + 1,
      })
    },
    onFieldNodeClick(data) {
      if (!data.id) {
        return
      }
      this._insertField({
        id: data.id,
        label: data.label,
        entry: data.entry,
      })
      // console.log('onFieldNodeClick', data, node, element)
    },
    // onCmCodeChange(code) {
    //   // this.codemirror.replaceSelection('"{{lanfeng}}"')
    //   console.log('onCmCodeChange', code, this.code)
    // },
    getValue() {
      var res = []
      this.codemirror.eachLine(function (line) {
        console.log(line)
        var text = line.text
        var offset = 0
        if (Object.keys(line).includes('markedSpans')) {
          line.markedSpans.map(function (span) {
            let field = span.marker.replacedWith.attributes['field']
            let entry = span.marker.replacedWith.attributes['entry']
            console.log(span, span.marker.replacedWith.attributes['field'], span.marker.replacedWith.attributes['entry'])
            let replace = '$' + field + '#' + (entry ? entry : '')
            text = text.slice(0, span.from + offset) + replace + text.slice(span.to + offset)
            offset += replace.length - (span.to - span.from)//替换后长度偏移
          })
        }
        res.push(text)
      })
      return {
        formula: {
          formula: res.join('\n'),
          text: '公式',
          type: 'formula',
        },
        widgets: [],
      }
    },
    setValue() {
      var p = []
      var e = []
      this.rely.formula.formula.split('\n').map((item, index) => {
        var d = ''
        console.log('item', item, index)
        item.split(new RegExp('(\\$[0-9a-zA-Z._#@]+)', 'g')).map((sub_item, sub_index) => {
          if (/^\$(_?[a-z]+_[0-9]{13}|[0-9]{13}_[0-9]+)/.test(sub_item)) {

            var entry
            var field = (entry = sub_item.replace('$', '').split('#'))[0]
            entry = entry[1]
            console.log('field', field, 'entry', entry)
            var label = sub_item
            try {
              if (entry !== '') {
                label = this.form.find(form => form.id === entry).fields.find(_field => _field.name === field).text
              } else {
                label = this.widgets.find(widget => widget.key === field).name
              }
            } catch (e) {
            }

            var r = CodeMirror.Pos(index, d.length)
            let a = this.fakeLabel(label)
            d += a
            var l = CodeMirror.Pos(index, d.length)
            console.log('sub_item', sub_item, sub_index)
            p.push({
              from: r,
              to: l,
              field: field,
              entry: entry,
              invalid: false,
              label: a,
            })
          } else {
            d += sub_item
          }

        })
        e.push(d)

      })
      this.codemirror.setValue(e.join('\n'))
      p.map((item) => {
        this._markField(item)
      })
    },
    fakeLabel: function (t) {
      return t ? t.replace(/[\[\]()'"]/g, ' ') : ''
    },
    _insertField(data) {
      const pos1 = this.codemirror.getCursor()
      const pos2 = {}
      pos2.line = pos1.line
      pos2.ch = pos1.ch

      //制作标签dom(颜色样式自行设置)
      var dom = document.createElement('span')
      dom.className = 'text-[#008DCD] bg-[#EBF5FF] px-[5px] m-px border-radius text-xs inline-block h-5 leading-5'
      dom.attributes['field'] = data.id
      dom.attributes['entry'] = data.entry
      dom.innerHTML = data.label

      const bookMark = dom.innerHTML
      const endPos = {line: pos2.line, ch: pos2.ch + dom.innerHTML.length}

      this.codemirror.replaceRange(bookMark, pos2)//先插入字符串

      //再对插入字符串进行标签制定（其实就是在codemirror中动态添加标签）
      this.codemirror.markText(pos2, endPos, {
        replacedWith: dom,
      })
    },
    _markField(t) {
      var dom = document.createElement('span')
      dom.className = 'text-[#008DCD] bg-[#EBF5FF] px-[5px] m-px border-radius text-xs inline-block h-5 leading-5'
      dom.attributes['field'] = t.field
      dom.attributes['entry'] = t.entry
      dom.innerHTML = t.label
      this.codemirror.markText(t.from, t.to, {
        handleMouseEvents: true,
        atomic: true,
        replacedWith: dom,
      })
    },
    onConfirm() {
      console.log('onConfirm', this.getValue())
      this.$emit('input', this.getValue())
    },
    getFields() {
      this.loading = true
      axios.get(zroute('app.form.fields', {app_id: this.app_id, form_id: this.form_id})).then(res => {
        this.loading = false
        this.form = res.data.form
        this.setValue()
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.code {

  ::v-deep .CodeMirror {
    height: 152px !important;

    .CodeMirror-scroll {
      height: 100% !important;
      overflow-x: hidden !important;
    }
  }
}

.methods, .fields {
  ::v-deep .el-tree {
    .is-leaf {
      display: none;
    }

    .el-tree-node__label {
      font-size: 12px;
      overflow-x: hidden;
    }
  }
}


</style>
